import { useFormik } from 'formik'
import { useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import logo from '../../assets/svg/NEMA.svg'
import api from '../../utils/api'
import styles from './Login.module.css'

const validationSchema = Yup.object({
  email_id: Yup.string().email('Invalid email format').required('Email is required'),
  password: Yup.string().required('Password is required'),
})

const Login = () => {
  const [error, setError] = useState('')

  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = async (values) => {
    try {
      const { data } = await api.post(`login_admin`, values)

      localStorage.setItem('user', JSON.stringify(data))
      localStorage.setItem('token', data.access_token)

      const redirectTo = location.state?.from || '/admin'

      navigate(redirectTo, { replace: true })
    } catch (error) {
      console.error(error)
      setError(error.response?.data?.error || 'Login failed. Please try again.')
    }
  }

  const formik = useFormik({
    initialValues: { email_id: '', password: '' },
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <div className={styles.loginPage}>
      <div className={styles.logoContainer}>
        <img src={logo} alt='Logo' className={styles.logo} />
      </div>
      <div className={styles.container}>
        <h2 className={styles.title}>Welcome to Nema Admin</h2>
        <p className={styles.subtitle}>Please sign in to access your dashboard</p>
        {error && <div className={styles.globalError}>{error}</div>}
        <form onSubmit={formik.handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='email_id'>
              Email
            </label>
            <div className={styles.inputGroup}>
              <input
                id='email_id'
                name='email_id'
                type='text'
                className={styles.input}
                autoFocus
                autoComplete='email'
                placeholder='Your admin email'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email_id}
              />
            </div>
            {formik.touched.email_id && formik.errors.email_id && <div className={styles.error}>{formik.errors.email_id}</div>}
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='password'>
              Password
            </label>
            <div className={styles.inputGroup}>
              <input
                id='password'
                name='password'
                type='password'
                className={styles.input}
                autoComplete='password'
                placeholder='Your secure password'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
            </div>
            {formik.touched.password && formik.errors.password && <div className={styles.error}>{formik.errors.password}</div>}
          </div>

          <button type='submit' className={styles.button} disabled={!formik.isValid || formik.isSubmitting}>
            {formik.isSubmitting ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p className={styles.signupText}>
          Don't have an account? <NavLink to='/admin/signup'>Sign up</NavLink>
        </p>
      </div>
    </div>
  )
}

export default Login
